exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".options-sty[data-v-4fb45966]{margin-right:5px;color:#290202}.pageation[data-v-4fb45966]{padding:30px 10px 20px;border-top:0;min-height:85px}.dialog-footer[data-v-4fb45966]{padding-bottom:20px}.dialog-footer .btn[data-v-4fb45966]{width:30%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4fb45966","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/ent-access/apiSet.vue
// module id = sdq0
// module chunks = 48